import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { AppAuthService } from './common';

@Component({
  selector: 'app-admin-nav',
  imports: [RouterModule, MatButtonModule, MatIconModule, MatMenuModule, MatDividerModule],
  templateUrl: './admin-nav.component.html',
  styleUrl: './admin-nav.component.scss',
})
export class AdminNavComponent {
  readonly authService = inject(AppAuthService);
}
